export default __webpack_public_path__ + "static/media/face_shades_yellow.973a059d.svg";